<template>
    <div class="components-plate-box" :style="{'justifyContent':justify}">
        <div class="components-plate"
             :style="{width:width,height:height,backgroundColor: plateColorValue,}"
             :class="plateColorValue ? '' : 'plate-none'">
            <p class="large-num" v-if="inside && plateNumber">{{plateNumber}}</p>
        </div>
        <span class="small-num" v-if="!inside && plateNumber"
              :style="{fontSize: fontSize?fontSize:'14px',
              paddingLeft:'3px',cursor:unClickAble?'inherit':'pointer',
              }"
              @click="clickPlateNumber"
        >{{plateNumber}}</span>
    </div>
    <!--<div v-else>-->
        <!--<span class="small-num" v-if="!inside && plateNumber"-->
              <!--:style="{fontSize: fontSize?fontSize:'14px',paddingLeft:'0'}">无车牌</span>-->
    <!--</div>-->
</template>
<style lang="scss" scoped>
    @import "plate.theme";

    .components-plate-box {
        min-width: 95px;
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        .components-plate {
            display: flex;
            align-items: center;
            border: 1px solid $color-line-deep;
            .large-num {
                width: 100%;
                text-align: center;
                font-size: $plate-large-num-font-size;
            }
        }
        .components-plate-car-type {
            display: flex;
            align-items: center;
            position: relative;
            border-radius: 5px;
            .large-num {
                width: 100%;
                text-align: center;
                font-size: $plate-large-num-font-size;
            }
            .car-type {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 28px;
                height: 14px;
                font-size: 12px;
                color: #333;
                line-height: 16px;
                text-align: center;
            }
        }
        .small-num {
            padding-left: $plate-small-num-padding;
            font-size: $plate-small-num-font-size;
        }
    }

    // 车牌颜色
    .plate-none {
        background-color: $color-back-primary;
        color: #fff;
        border: 1px solid $color-line-deep;
        position: relative;
        overflow: hidden;
        &:before {
            width: 100%;
            text-align: center;
            content: '?';
            color: $color-danger;
            font-size: 12px;
        }
        /*@mixin line {
          content:'';
          position:absolute;
          width:200%;
          height:1px;
          background-color:$color-danger;
          left:0;
        }
        &:before{
          @include line;
          bottom:0;
          transform:rotate(45deg) translateX(-50%);
        }
        &:after{
          @include line;
          top:0;
          transform:rotate(-45deg) translateX(-50%);
        }*/
    }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/plate/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/plate/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/plate/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-plate')
  export default {
    name: 'base-plate', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-plate': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>